<template>
    <type-based-transition transition-type="fadeUpDown">
		<section>
			<globe-bg />
			<boat />
			<article>
				<h3>OOOOPS!</h3>
				<h2 v-html="type ? type.message : 'ERROR 404'"></h2>
				<p>Sorry, we are experience issues in processing your request. Please try again in a moment</p>
				<p>If the problem persist please drop us an email at <a href="mailto:administration@ryoma.eu">administration@ryoma.eu</a></p>
				<p>Return to the <router-link :to="{name:'home'}">HomePage</router-link> </p>
			</article>
			<pin 
				:color="'#409DAF'"/>
			<pin 
				:color="'#B6D43F'"/>
			<pin 
				:color="'#BA3660'"/>
			<pin 
				:color="'#D2482D'"/>
			<pin 
				:color="'#F7C947'"/>
		</section>
    </type-based-transition>
</template>

<script>
import TypeBasedTransition from "../../transitions/TypeBasedTransition.vue"
import GlobeBg from '@/components/origami/GlobeBg'
import Boat from '@/components/origami/Boat'
import Pin from '@/components/origami/Pin'

export default {
	name: 'generic-error',
	components: {
		TypeBasedTransition,
		GlobeBg,
		Boat,
		Pin
	},
	computed: {
		type: function() {
			return this.$route.params.errType
		}
	}
	
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';

	section {
		@include grid(12);
		background-color: $accent_1;

		svg {
			grid-row-start: 1;

			&.globe {
				grid-column: 1/ span 12;
			}
			&.boat-origami {
				grid-column: 2 / span 5;
			}
			&.pin-origami {
				position: absolute;
				bottom: 0;
				width: 150px;

				&:nth-of-type(3) {
					left: 5vmin;
					transform: translate(0, -100%);
				}

				&:nth-of-type(4) {
					left: 1vmin;
					transform: translate(-5vmin, -180%) scale(.5);
				}

				&:nth-of-type(5) {
					left: 10vmin;
					transform: translate(0, -240%) scale(.2);
				}
				&:nth-of-type(6) {
					left: auto;
					right: 5vmin;
					transform: translate(0, -100%);
				}
				&:nth-of-type(7) {
					left: auto;
					right: 2vmin;
					transform: translate(4vmin, -220%) scale(.3);
				}
			}
		}

		article {
			padding-top: 5vmin;
			grid-row-start: 1;
			grid-column: 7 /span 4;
			line-height: 1;

			h2,p {
				color: white;
			}
			h2 {
				letter-spacing: -3px;
			}
		}
	}
</style>